import { ISystemUserDetailDTO } from 'api/swagger/ApiClient';
import { autoinject, BindingEngine, customElement, newInstance } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ValidationController, ValidationRules } from 'aurelia-validation';
import { watch } from 'aurelia-watch-decorator';
import { DialogHelper } from 'framework/aurelia_dialogs/dialog-helper';
import { cloneDeep } from 'framework/script_utilities/object-equalizer';
import { UserCountryRoleModel } from 'model/forms/user-country-role-model';
import { ModelBase } from 'support/base_classes/model-base';
import { ValidationHelper } from 'support/validation';
import { BootstrapGroupRenderer } from '../framework/aurelia_tools/bootstrap-group-renderer';

@autoinject
@customElement('countries-roles-user-panel')
export class CountriesRolesUserPanelCustomElement extends ModelBase<ISystemUserDetailDTO> {
  @bindable userCountryRoleModel: UserCountryRoleModel;
  backup: ISystemUserDetailDTO = null;
  submitButtonVisible = false;
  cancelButtonVisible = false;

  constructor(bindingEngine: BindingEngine, private dialogHelper: DialogHelper, private validationHelper: ValidationHelper, @newInstance() private validationController: ValidationController, validationRenderer: BootstrapGroupRenderer) {
    super(bindingEngine);
    validationRenderer.allowedParents = 'bs-form-input';
    this.validationController.addRenderer(validationRenderer);
  }

  bind() {
    this.model = this.userCountryRoleModel.user;
    super.bind();
    this.backup = cloneDeep(this.model);
  }

  modelChanged(newValue: ISystemUserDetailDTO) {
    super.modelChanged(newValue);
    ValidationRules
      .ensureObject<ISystemUserDetailDTO>().required()
      .ensure(model => model.countriesContactEmail).displayName('Countries Email').email()
      .on(this.model);
    this.validationController.reset();
    this.updateButons();
  }

  async submit() {
    if (await this.validationHelper.validate(this.validationController)) {
      this.rebindData(await this.userCountryRoleModel.saveUser(this.model));
    }
  }

  async cancel() {
    if (!this.changed || await this.dialogHelper.confirm({ dialogTitle: 'Cancel your changes?', message: 'You haven\'t saved the form yet. If you proceed, your changes will be lost!', okTitle: 'Sure, do it!', cancelTitle: 'Back to form' })) {
      this.changed && this.rebindData(this.backup);
    }
  }

  private rebindData(dto: ISystemUserDetailDTO) {
    this.userCountryRoleModel.user = dto;
    this.model = dto;
    this.backup = cloneDeep(this.model);
  }

  @watch((x: CountriesRolesUserPanelCustomElement) => x.changed)
  private updateButons() {
    this.userCountryRoleModel.isUserEditing = this.changed;
    this.submitButtonVisible = this.changed;
    this.cancelButtonVisible = this.changed;
  }
}
